/* eslint-disable no-unused-vars */
/**
 * Import 3rd party packages
 */

/**
 * Import stylesheet
 */
import $ from 'jquery';
import slick from 'slick-carousel';
import '../scss/main.scss';
import MiniCart from "./functions/MiniCart";

$(document).ready(function () {
    document.getElementById("cookiesPopup").querySelector('.cookies__close-btn').addEventListener('click', function (e) {
        e.preventDefault()
        const cookieExpiry = 30;
        const cookiePath = "/";
        createCookie('seen-cookiePopup', 'yes', cookieExpiry, cookiePath);
        document.getElementById("cookiesPopup").classList.add('cookies--close')
    });

    const cookiePopup = readCookie('seen-cookiePopup');

    if (cookiePopup != null && cookiePopup == 'yes') {
        console.log(document.getElementById("cookiesPopup"))
        document.getElementById("cookiesPopup").classList.add('cookies--close')
    } else {
        document.getElementById("cookiesPopup").classList.remove('cookies--close')
    }

    customInputNumberEvents()

    let productCarousel = $('#productsCarousel')
    let productCarouselNav = $('#productsCarouselNav')
    if (productCarousel.length > 0) {
        productCarousel.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: false,
            infinite: true,
            asNavFor: '#productsCarouselNav',
            responsive: [
                {
                    breakpoint: 990,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        fade: false,
                        infinite: true,
                        dots: true,
                        asNavFor: false,
                    }
                }
            ]
        })
    }
    if (productCarouselNav.length > 0) {
        productCarouselNav.slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: '#productsCarousel',
            dots: false,
            arrows: false,
            centerMode: false,
            vertical: true,
            verticalSwiping: true,
            infinite: true,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 1,
                        infinite: true,
                        centerMode: true,
                        centerPadding: 15,
                        vertical: false,
                        verticalSwiping: false,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        infinite: true,
                        centerMode: true,
                        centerPadding: 15,
                        vertical: false,
                        verticalSwiping: false,
                    }
                },
                {
                    breakpoint: 400,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        centerMode: true,
                        centerPadding: 15,
                        vertical: false,
                        verticalSwiping: false,
                    }
                }
            ]
        })
    }

    $('.nav-list .nav-list__link').on('click', (e) => {
        if (window.innerWidth < 991) { // Apply only if the screen width is less than 991px
            const $parentItem = $(e.target).closest('.nav-list__item');

            // Check if the parent item has a child with the 'nav-list-child' class
            if ($parentItem.find('.nav-list-child').length > 0) {
                e.preventDefault(); // Prevent default only if there is a 'nav-list-child'

                // Toggle the 'active' class
                if ($parentItem.hasClass('active')) {
                    $parentItem.removeClass('active'); // Remove active if already active
                } else {
                    $('.nav-list .nav-list__item').removeClass('active'); // Remove active from all other items
                    $parentItem.addClass('active'); // Add active to the clicked item
                }
            }
        }
    });

    checkoutActions();
    refreshFragment()
    openSearchBar();
    sendNewsletter();
    new MiniCart;

})


function createCookie(name, value, days, path) {
    let expires = "";
    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    } else expires = "";
    document.cookie = name + "=" + value + expires + "; path=" + path;
}

function readCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}


function customInputNumberEvents(containerClassName) {
    let currentValue = 0;

    $('body').on('click', '.custom-number-input > .custom-number-input__counter-down', (e) => {
        const input = $(e.target).siblings('input')
        currentValue = input.val()
        input.data('prevVal', currentValue)
        if (currentValue > 1) {
            currentValue--
            console.log(input)
            input.val(currentValue).trigger('change')
        }
    })
    $("body").on('click', '.custom-number-input > .custom-number-input__counter-up', (e) => {
        const input = $(e.target).siblings('input')
        currentValue = input.val()
        input.data('prevVal', currentValue)
        currentValue++
        input.val(currentValue).trigger('change')
    })
}

function checkoutActions() {
    $('#goToPayment').click(function () {
        $('#step1').addClass('d-none')
        $('#step2').removeClass('d-none')
    })

    if ($('.checkout')) {
        $('a[data-step="1"]').click(function (e) {
            e.preventDefault()
            $('#step1').removeClass('d-none')
            $('#step2').addClass('d-none')
        })
    }
    if ($('.checkout')) {
        $('a[data-step="2"]').click(function (e) {
            e.preventDefault()
            $('#step1').addClass('d-none')
            $('#step2').removeClass('d-none')
        })
    }
}

function refreshFragment() {
    $(document).ajaxComplete(function (event, request, settings) {
        if (
            settings.url === "/?wc-ajax=get_refreshed_fragments" ||
            settings.url === "/?wc-ajax=update_order_review" ||
            settings.url === "/?wc-ajax=update_shipping_method"
        ) {
            const cartContent = $('.js-miniCartContent')

            fetch(window.global.ajax_url + "?action=refreshCart", {
                method: "POST", //* GET, POST, PUT, DELETE, etc.
                mode: "cors", // no-cors, *cors, same-origin
                cache: "no-cache", //* default, no-cache, reload, force-cache, only-if-cached
                credentials: "same-origin", // include, *same-origin, omit
                headers: {
                    // "Content-Type": "application/json",
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                redirect: "follow", // manual, *follow, error
                referrerPolicy: "no-referrer", // no-referrer, *client
                body: new URLSearchParams({
                    security: window.global.security,
                }),
            })
                .then((resp) => resp.json())
                .then((data) => {
                    if (data.success) {
                        if (data.data.cart_content) {
                            cartContent.empty().append(data.data.cart_content)
                        }
                    }
                })
                .finally(() => {
                    parent.removeClass('small-cart-item--loader')
                })
        }
    });
}

function openSearchBar() {
    $('.js-openSearchbar').click((e) => {
        e.preventDefault()

        $('.searchbar').toggleClass('searchbar--open')

    })
}

function sendNewsletter() {
    const newsletterForm = $('#newsletterForm')
    if (newsletterForm) {
        newsletterForm.submit(function (e) {
            e.preventDefault()
            const termsContainer = $('#terms')
            const messageContainer = $('#afterSaveMessage')
            const day = $('#day')
            const month = $('#month')
            const email = newsletterForm.find('#newsletterEmail')
            const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
            email.removeClass('newsletter-form__input--invalid')
            if (!emailPattern.test(email.val())) {
                email.addClass('newsletter-form__input--invalid')
                return;
            } else {
                email.removeClass('newsletter-form__input--invalid')
            }

            if (termsContainer.is(':checked') === false) {
                termsContainer.parent('.newsletter-form-checkbox').addClass('newsletter-form-checkbox--invalid')
                return;
            } else {
                termsContainer.parent('.newsletter-form-checkbox').removeClass('newsletter-form-checkbox--invalid')
            }

            const ajaxUrl = window.global.ajax_url
            const security = window.global.newsletter_security

            const data = {
                action: 'subscribe_newsletter',
                security: security,
                email: email.val(),
                birth_date: '',
                accept_terms: 1
            };

            if (day.val() && month.val()) {
                data.birth_date = `${day.val()}/${month.val()}`
            }

            fetch(ajaxUrl, {
                method: "POST", //* GET, POST, PUT, DELETE, etc.
                mode: "cors", // no-cors, *cors, same-origin
                cache: "no-cache", //* default, no-cache, reload, force-cache, only-if-cached
                credentials: "same-origin", // include, *same-origin, omit
                headers: {
                    // "Content-Type": "application/json",
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                redirect: "follow", // manual, *follow, error
                referrerPolicy: "no-referrer", // no-referrer, *client
                body: new URLSearchParams({...data}),
            })
                .then((resp) => {
                    return resp.json()
                })
                .then((data) => {
                    if (data.success) {
                        email.val('');
                        termsContainer.prop('checked', false)
                        day.val('');
                        month.val('')
                        messageContainer.removeClass('d-none')
                        messageContainer.html(data.data);
                    } else {
                        email.addClass('newsletter-form__input--invalid')
                    }
                })
        });
    }
}

